import mod from "-!./Lightbox.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Lightbox.js?vue&type=script&lang=js&external"